module.exports = __webpack_public_path__ + "img/vertical-dots.4d43338b.png";